import { render } from "./AdminUserSettings.vue?vue&type=template&id=f062a616"
import script from "./AdminUserSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/AdminUserSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f062a616"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f062a616', __exports__)) {
    api.reload('f062a616', __exports__)
  }
  
  module.hot.accept("./AdminUserSettings.vue?vue&type=template&id=f062a616", () => {
    api.rerender('f062a616', render)
  })

}


export default __exports__